import React from 'react';

export function Input({ 
  type = 'text',
  placeholder,
  value,
  onChange,
  disabled = false,
  className = '',
  maxLength,
  autoFocus = false,
  ...props 
}) {
  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      disabled={disabled}
      maxLength={maxLength}
      autoFocus={autoFocus}
      className={`w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition ${className}`}
      {...props}
    />
  );
}